const manageHomeExperiences = ({detail: data}) => {
    const variation = data?.variation || CookieService.getCookie('homePageExperience');   
    switch(variation) {
        case "priceVariantB":
        case "seasonalPriceVariantB":
            priceComponent(data)
            break;
        case "registerModal":
        case "qrCodeModal":    
            registerModal(data);
            break; 
        default:
    } 
}
document.addEventListener('evergageValidateHomeComponent', manageHomeExperiences);

const spHomeExperiences = () => {
    let blockElements = document.querySelector('.sp-price-component');
    if(blockElements) {
        //display the block/field
        blockElements?.classList.remove('d-none')
    }
}
document.addEventListener('evergageSPHome', spHomeExperiences);

const managePHHomeExperience = () => {
    const existingPHId = document.getElementById('hero-banner-ph');
    const priceVariantCalcPH = document.getElementById('money-transfer-ph');
    const phExpCookie = CookieService.getCookie('txnR4ExperienceForPH');
    if(phExpCookie === 'true') {
        if(existingPHId){
            existingPHId.classList.add('d-none');
            existingPHId.classList.remove('d-block');
        }
        if(priceVariantCalcPH) {
            priceVariantCalcPH.classList.remove('d-none');
        }
    } else if(existingPHId && priceVariantCalcPH) {
        existingPHId?.classList.add('d-block');
        priceVariantCalcPH?.classList.add('d-none');
    }
}

managePHHomeExperience();

const manageUSHomeExperience = (priceVariantBId, priceVariantCalcWidgetEL, priceBenefits, summaryBenefitsCalc) => {
    if(priceVariantBId || priceBenefits || priceVariantCalcWidgetEL || summaryBenefitsCalc){
        priceVariantBId?.classList.remove('d-none');
        priceBenefits?.classList.replace('d-none', 'd-block');
        priceVariantCalcWidgetEL?.classList.replace('d-block', 'd-none');
        summaryBenefitsCalc?.classList.replace('d-block', 'd-none');
    }
}